/**
 * Determines if a range is valid (ascending alphabetical order)
 * e.g., "AF" -> true, "AG" -> true, "BA" -> false, "AA" -> false
 */
export function isValidRange(range: string): boolean {
    if (range.length !== 2) {
        return false;
    }

    const startLetter = range[0];
    const endLetter = range[1];

    // Check if both are uppercase letters
    if (!/^[A-Z]$/.test(startLetter) || !/^[A-Z]$/.test(endLetter)) {
        return false;
    }

    const startCharCode = startLetter.charCodeAt(0);
    const endCharCode = endLetter.charCodeAt(0);

    // Must be ascending and not the same letter
    return startCharCode < endCharCode;
}
